import React from "react";
import { Wallet } from "./Wallet";
import { Toaster } from "react-hot-toast";
import { Deal } from "./Deal";

function DealApp() {
  return (
    <div className="app">
      <div className="container">
        <h2
          style={{
            marginTop: 0,
            color: "#454f5b",
            fontFamily: "font-family: Public Sans,sans-serif",
          }}
        >
          Discord Deal Sender
        </h2>
        <Wallet>
          <Deal />
        </Wallet>
        <Toaster />
      </div>
    </div>
  );
}

export default DealApp;
